import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import ProductCatalog from './components/ProductCatalog';
import CartDrawer from './components/Cart';
import { CartProvider } from './contexts/CartContext';
import { useState } from 'react';
import './styles/nexus-brew.css';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#d1346e', // Неоновый розовый
      light: '#ff4d8d',
      dark: '#a02859',
    },
    secondary: {
      main: '#40c4cc', // Неоновый голубой
      light: '#66d4dc',
      dark: '#3a9da3',
    },
    background: {
      default: '#0a0a0a', // Очень темный фон
      paper: 'rgba(20, 20, 20, 0.8)', // Полупрозрачный темный
    },
    text: {
      primary: '#e0e0e0',
      secondary: '#9a9a9a',
    },
    info: {
      main: '#7b45c7', // Неоновый фиолетовый
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(10, 10, 10, 0.95)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(209, 52, 110, 0.3)',
          boxShadow: '0 2px 20px rgba(209, 52, 110, 0.3)',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#e0e0e0',
          '&:hover': {
            background: 'rgba(209, 52, 110, 0.2)',
            boxShadow: '0 0 20px rgba(209, 52, 110, 0.4)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          background: 'linear-gradient(135deg, #d1346e 30%, #7b45c7 50%, #40c4cc 90%)',
          boxShadow: '0 4px 15px rgba(209, 52, 110, 0.4)',
          '&:hover': {
            boxShadow: '0 6px 25px rgba(209, 52, 110, 0.6)',
          },
        },
        outlined: {
          borderColor: '#d1346e',
          color: '#e0e0e0',
          '&:hover': {
            background: 'rgba(209, 52, 110, 0.1)',
            boxShadow: '0 0 15px rgba(209, 52, 110, 0.3)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: 'rgba(20, 20, 20, 0.8)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(209, 52, 110, 0.2)',
        },
      },
    },
  },
});

function App() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <CartProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <div className="app" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Animated background elements */}
            <div className="static-pattern"></div>
            <div className="hex-pattern"></div>
            <div className="bg-shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
              <div className="shape shape-4"></div>
              <div className="shape shape-5"></div>
            </div>
            <div className="grid-overlay"></div>
            
            <Header onCartClick={() => setCartOpen(true)} />
            <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
            <Box sx={{ 
              flex: 1, 
              padding: '7rem 1rem 1rem 1rem', 
              position: 'relative', 
              zIndex: 2,
              '&:before': {
                content: '""',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: 'url(/images/background.gif)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                opacity: 0.3,
                zIndex: -1
              }
            }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/catalog" element={<ProductCatalog />} />
              </Routes>
            </Box>
            <Footer />
          </div>
        </Router>
      </ThemeProvider>
    </CartProvider>
  );
}

export default App;
